import axios from 'axios';
import Api from './Api';

class CalendarioApi extends Api {
    async recuperarCalendario(anos) {
        const parametroAno = anos.length > 0 ? `?ano=${anos.join('&ano=')}` : '';
        const url = `${this.configuracao.urlCalendario}${parametroAno}`;
        let result = await this.fetch(url);
        return result.data;
    }
}

export default CalendarioApi;
